import { AppIconsNames, useIconStyles } from '@organization/layout/Applications'
import { useMemo } from 'react'

const isAppIcon = (name: string): name is AppIconsNames => {
  return Object.values(AppIconsNames).includes(name as AppIconsNames)
}

export const useApplicationIcon = (applicationName: string) => {
  const { styles } = useIconStyles()

  const applicationIconColor = useMemo(() => {
    if (isAppIcon(applicationName)) {
      return styles[applicationName]
    }

    return styles[AppIconsNames.Default]
  }, [applicationName, styles])

  return applicationIconColor
}
